import * as React from "react";
import * as Immutable from "immutable";
import isNil from "lodash/isNil";
import RequiredParametersForViewForm from "enterprise/parameters/components/RequiredParametersForViewForm";
import ParameterBinding from "views/logic/parameters/ParameterBinding";
const parameterHasValue = (parameter, executionState) => executionState.parameterBindings.has(parameter.name) && !isNil(executionState.parameterBindings.get(parameter.name).value) && executionState.parameterBindings.get(parameter.name).value !== "";
const showParameterFormIfMissingValues = async ({ view: { search }, view, retry, executionState }) => {
  const { parameters } = search;
  const { requiredParameters } = search;
  const requiresParameters = !requiredParameters.filter((p) => !parameterHasValue(p, executionState)).isEmpty();
  if (requiresParameters) {
    const boundParameters = Immutable.Map(
      parameters.filter((p) => !p.optional && p.needsBinding).map((p) => {
        const { value } = executionState.parameterBindings.get(p.name, ParameterBinding.empty());
        return value ? p.toBuilder().binding(ParameterBinding.forValue(value)).build() : p;
      }).map((p) => [p.name, p])
    );
    throw /* @__PURE__ */ React.createElement(
      RequiredParametersForViewForm,
      {
        parameters: boundParameters,
        onSubmit: retry,
        view,
        executionState
      }
    );
  }
  return [view, executionState];
};
export default showParameterFormIfMissingValues;
